import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'sherwood-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Sherwood Urgent Care Arkansas',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1-615-988-2000,
  email: 'support@sherwoodurgentcare.com',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/sherwood/index.js